import {
  WSCard,
  WSFlexBox,
  WSIcon,
  WSList,
  WSText
} from "@wingspanhq/fe-component-library";
import { formatNumber } from "accounting";
import React from "react";
import { BulkActionProgress } from "../types";

type Props = {
  progress: BulkActionProgress;
};

export const BulkActionProgressCard: React.FC<Props> = props => (
  <WSCard>
    <WSList gap="L">
      <WSFlexBox alignItems="center" justify="space-between" gap="S">
        <WSFlexBox alignItems="center" gap="S">
          <WSIcon name="check-circle" color="green400" />
          <WSText.ParagraphSm>Complete:</WSText.ParagraphSm>
        </WSFlexBox>
        <WSText.ParagraphSm>
          {formatNumber(props.progress.successful)}
        </WSText.ParagraphSm>
      </WSFlexBox>

      {props.progress.failed > 0 && (
        <WSFlexBox alignItems="center" justify="space-between" gap="S">
          <WSFlexBox alignItems="center" gap="S">
            <WSIcon name="exit-circle" color="red400" />
            <WSText.ParagraphSm>Failed:</WSText.ParagraphSm>
          </WSFlexBox>
          <WSText.ParagraphSm>
            {formatNumber(props.progress.failed)}
          </WSText.ParagraphSm>
        </WSFlexBox>
      )}
    </WSList>
  </WSCard>
);
